import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SingleOption from './SingleOption';
import t from "../../../../languages/pl";
import ConfirmationDialog from "../../../Common/ConfirmationDialog";

const TrophyOption = props => {
    const { isCollectingTrophies, onConfirmClick } = props;
    const [collectingTrophiesState, setCollectingTrophiesState] = useState(false);
    const [collectingTrophiesDialog, setCollectingTrophiesDialog] = useState(false);

    useEffect(() => {
        setCollectingTrophiesState(isCollectingTrophies);
    }, [isCollectingTrophies]);

    return (
        <Fragment>
            <SingleOption
                title={t.collectingTrophiesInformation}
                checked={collectingTrophiesState}
                onChange={() => setCollectingTrophiesDialog(true)}
            />
            <ConfirmationDialog
                open={collectingTrophiesDialog}
                onClose={() => setCollectingTrophiesDialog(false)}
                onSubmit={() => onConfirmClick(!collectingTrophiesState)}
                action={collectingTrophiesState ? t.stopCollectingTrophiesConfirmation : t.startCollectingTrophiesConfirmation}
                additionalText={collectingTrophiesState ? t.willCauseRemoveAllTrophiesFromTheBase : t.willCauseStartCollectingTrophiesByDrivers}
            />
        </Fragment>
    );
};

TrophyOption.propTypes = {
    isCollectingTrophies: PropTypes.bool,
    onConfirmClick: PropTypes.func,
};

export default TrophyOption;